"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LettersSearch;
const react_1 = __importStar(require("react"));
const GeneralModalButtons_1 = require("../../View/Modals/GeneralModalButtons");
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const FilterableTableContext_1 = require("../../View/Resultsets/FilterableTable/FilterableTableContext");
const LetterFilterBody_1 = require("./LetterFilterBody");
const LettersController_1 = require("./LettersController");
const LetterRowContent_1 = require("./LetterRowContent");
const LetterModalBodiesPartial_1 = require("./Modals/LetterModalBodiesPartial");
const LetterModalButtons_1 = require("./Modals/LetterModalButtons");
const SigningRowActions_1 = require("../Signing/SigningRowActions");
function LettersSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    function buildLabelFromEntities(entities) {
        if (!entities || entities.length === 0)
            return "";
        let label = "";
        for (let i = 0; i < entities.length - 1; i++) {
            label += entities[i].name + "\n ";
        }
        label += entities[entities.length - 1].name;
        return label;
    }
    function makeEntitiesLabel(letter) {
        const mainEntitiesLabel = buildLabelFromEntities(letter._entitiesMain);
        const ccEntitiesLabel = buildLabelFromEntities(letter._entitiesCc);
        if (!mainEntitiesLabel)
            return react_1.default.createElement(react_1.default.Fragment, null);
        let label = mainEntitiesLabel;
        if (ccEntitiesLabel?.length > 0) {
            label += "\n\nDW: " + ccEntitiesLabel;
        }
        return react_1.default.createElement("div", { style: { whiteSpace: "pre-line" } }, label);
    }
    function renderIconTdBody(letter) {
        return react_1.default.createElement(LetterRowContent_1.LetterRowMarkers, { letter: letter });
    }
    function renderStatus(letter) {
        const { handleEditObject } = (0, FilterableTableContext_1.useFilterableTableContext)();
        return (react_1.default.createElement(GeneralModalButtons_1.PartialEditTrigger, { modalProps: {
                initialData: letter,
                modalTitle: `Edycja statusu pisma ${letter.number}`,
                modalSubtitle: `Dotyczy: ${letter.description}`,
                repository: LettersController_1.lettersRepository,
                ModalBodyComponent: LetterModalBodiesPartial_1.LetterModalBodyStatus,
                onEdit: (editedFields) => {
                    handleEditObject({ ...letter, ...editedFields });
                },
                fieldsToUpdate: ["status"],
            } },
            react_1.default.createElement(CommonComponents_1.LetterStatusBadge, { status: letter.status || "" })));
    }
    function renderRowContent(letter) {
        return (react_1.default.createElement(LetterRowContent_1.LetterRowContent, { letter: letter, context: "contract", renderStatus: (rowLetter) => renderStatus(rowLetter) }));
    }
    return (react_1.default.createElement(FilterableTable_1.default, { id: "contractsLetters", title: title, FilterBodyComponent: LetterFilterBody_1.LettersFilterBody, tableStructure: [
            // Kolumny „Utworzono” i „Wysłano” zeszły do paska meta w bloku pisma
            // (decyzja właściciela 2026-07-31) — odzyskane miejsce idzie na treść.
            // Suma colLg musi zostawić 1 kolumnę na RowActionMenu aktywnego wiersza,
            // czyli maks. 11 — przy 12 menu zawija się na nowy wiersz i ląduje po lewej.
            { renderThBody: () => react_1.default.createElement("i", { className: "fa fa-inbox fa-lg" }), renderTdBody: renderIconTdBody, colLg: 1 },
            { header: "Pismo", renderTdBody: renderRowContent, colLg: 7 },
            { header: "Odbiorcy", renderTdBody: makeEntitiesLabel, colLg: 3 },
        ], AddNewButtonComponents: [LetterModalButtons_1.OurLetterAddNewModalButton, LetterModalButtons_1.IncomingLetterAddNewModalButton], EditButtonComponent: LetterModalButtons_1.LetterEditModalButton, RowActionMenuComponents: [
            LetterModalButtons_1.RespondToLetterButton,
            LetterModalButtons_1.ExportOurLetterContractToPDFButton,
            SigningRowActions_1.SignOurLetterPdfButton,
            SigningRowActions_1.UploadSignedLetterButton,
        ], isDeletable: true, repository: LettersController_1.lettersRepository, selectedObjectRoute: "/letter/" }));
}
